import React from 'react';
import './development.css';

const Development = () => {
    return (
        <div className="development-container">
            <div className="white-square">
                <p className="development-message">THE PRODUCT IS UNDER DEVELOPMENT!</p>
            </div>
        </div>
    );
};

export default Development;
